'use strict';
import appConfigModule from '../../appConfig/appConfig.module';
import { Injectable, Inject } from 'ng-metadata/core';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {JournalsService} from "../journals.service";
import {DatabasesService} from "../databases.service";


@Injectable()
export class DatabasesCategorizeService {
	
	private restIlsUrl: string;
	private breadcrumbs:Object;
	private test:Object;
	private iscategories=true;
	private isactivate=false;
    private categoriesResponse:Object[] = new Array();
	private _isMobileDBSlider = false;
    public DELIMITER = "─";
    private journalCategories=true;
    private dbCategories=true;
	
	constructor(@Inject('$http') private $http: ng.IHttpService,
				@Inject('restBaseURLs') restBaseURLs,
				private configurationUtil: ConfigurationUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private databasesService:DatabasesService,
                private journalsService:JournalsService){
	    this.$http = $http;
	    this.restIlsUrl = restBaseURLs.dbCategoriesBaseURL;
	}

	
	
	public getCategories(type) {
	    return this.$http.get(this.restIlsUrl+'?type='+type);
	}

    public setCategories(iscategories, type:string){
        if (type==='journal')
            this.journalCategories=iscategories;
        else if (type==='db')
            this.dbCategories=iscategories;
        this.isactivate=true;
	}
	
	public isCategories(type:string){
        if (type==='journal')
            return this.journalCategories;
        else if (type==='db')
            return this.dbCategories;
        else return false;
	}

	public isActivate(){
		return this.isactivate;
	}

	public getCategory(item) : any{
        if(item){
            if(item.dbcategories){
                if (this.configurationUtil.getBackendSystem() === 'suprima') {
                    return item.dbcategories[0]? item.dbcategories[0].dbcategory : [];
                }else{
                    return item.dbcategories.dbcategory;
                }
            }else{
                return item.dbcategory;
            }
        }else{
            console.log("ERROR: Item is not defined.")
            return null;
        }

    }

    public setCategory(item, category){
        if (item.dbcategory) {
            item.dbcategory = category;
        }
        else {
            if (this.configurationUtil.getBackendSystem() === 'suprima') {
            	item.dbcategories= [{dbcategory: category}];
        	}
        	else{
                item.dbcategories.dbcategory = category;
			}
        }
	}

	get isMobileDBSlider () {
		return this._isMobileDBSlider;
	}

	set isMobileDBSlider (isMobileDBSlider) {
		this._isMobileDBSlider = isMobileDBSlider;
	}

    public isSearchFromBarDBorJournals() {
        if (this.DBOrJournal ) {
            if (this.$stateParams['query'] && this.$stateParams['query'].indexOf('any') > -1)
                return true;
            else {
                return false;
            }
        }

        else {
            return false;
        }
    }

    public isSearchFromCategoryTree() {
        if (this.DBOrJournal) {
            if (this.$stateParams['query'] && this.$stateParams['query'].indexOf('contains,dbcategory') > -1)
                return true;
            else {
                return false;
            }
        }

        else {
            return false;
        }

    }
    public isSearchFromLetters () {
        if (this.DBOrJournal) {
            if (this.$stateParams['databases'] && this.$stateParams['databases'].indexOf('letter') > -1 ||
                (this.$stateParams['journals'] && this.$stateParams['journals'].indexOf('letter') > -1))
                return true;
            else {
                return false;
            }
        }

        else {
            return false;
        }
    }
    get DBOrJournal(){
	    return this.databasesService.isDBSearch() || this.journalsService.isJournalSearch();
    }
    public getTName(name) {
        return this.getTNameWithDelimiter(name, this.DELIMITER);
    }

    public getTNameWithDelimiter(name, delimiter) {
        if (!name) return "";
        let tnames = name.split(delimiter);
        let tname = tnames[tnames.length - 1];
        return tname.split(' ').join('_');
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/databasesCategorize/databasesCategorize.service.ts